<template>
  <div id="register">
    <h3 class="greetingHeader">Welcome To PreEvent</h3>

    <b-container>
      <DialogContainer v-if="passwordResetLink">
        <div class="resetLink">
          <h3>Password Reset link sent</h3>
          <p>check your email to reset your password</p>
          <router-link to="/login"
            ><b-button>Go back to login</b-button></router-link
          >
        </div>
      </DialogContainer>
      <DialogContainer v-if="passwordResetLinkFailed">
        <div class="resetLinkFailed">
          <h3>Reset link not sent</h3>
          <p>Invalid Email</p>
          <b-button @click="toggleDialog">Try again</b-button>
        </div>
      </DialogContainer>
      <b-form @submit.prevent="handleSubmit" id="registerForm">
        <!-- Row 1: First Name and Last Name -->
        <b-row>
          <h3 class="">Reset password</h3>
          <p>
            Please enter your email address, and we'll email you a link to reset
            your password
          </p>
        </b-row>
        <!-- Row 2: Email, Password, and Re-enter Password -->
        <b-row>
          <b-col md="12">
            <b-form-group class="" label="Email" label-for="email">
              <div class="password-wrapper">
                <b-form-input
                  id="email"
                  type="email"
                  v-model="form.email"
                  placeholder="Enter your email"
                ></b-form-input>
                <b-button class="password-toggle" variant="link">
                  <i class="fas fa-at"></i>
                </b-button>
              </div>
              <span v-if="errors.email" class="error-message">{{
                errors.email
              }}</span>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Row 3: Register Button -->
        <b-row>
          <b-col>
            <b-button
              class="w-100"
              type="submit"
              id="registerButton"
              :disabled="showLoading"
            >
              <template v-if="showLoading">
                <img
                  src="../../assets/admin_loading.gif"
                  alt="Loading"
                  class="loader"
                />
              </template>
              <template v-else> Send </template>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <b-container class="text-center">
        <router-link to="/login" id="loginLink">Login</router-link>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import DialogContainer from "@/components/DialogContainer.vue";
import axios from "axios";
import { API_BASE_URL } from "@/utils/apiBase";

export default {
  components: {
    DialogContainer,
  },
  data() {
    return {
      form: {
        email: "",
      },
      errors: {
        email: "",
      },
      showLoading: false,
      passwordResetLink: false,
      passwordResetLinkFailed: false,
    };
  },
  methods: {
    validateForm() {
      this.errors.email = this.form.email ? "" : "Email is required";
    },
    handleSubmit() {
      // Handle form submission here
      this.showLoading = true;
      this.validateForm();
      if (this.errors.email) {
        this.showLoading = false;
        // after request sa server
        return; // Stop form submission if there are errors
      }
      axios
        .post(`${API_BASE_URL}/forgot-password`, {
          admin_users_email: this.form.email,
        })
        .then((response) => {
          console.log('Response', response)
          this.passwordResetLink = true;
        })
        .catch((error) => {
          console.error("Login failed:", error.response.data);
          this.passwordResetLinkFailed = true;
          this.showLoading = false;
        }); // Proceed with form submission, e.g., send data to an API
    },
    toggleDialog() {
      this.passwordResetLinkFailed = false;
    },
  },
};
</script>

<style scoped>
#register {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #bfc7d6;
  padding: 40px 40px 120px 40px;
  border-radius: 5px;
  font-family: "Kumbh Sans", sans-serif;
  font-weight: 600;

}

h1 {
  font-weight: 600;
}
.greetingHeader {
  margin-bottom: 40px;
}
p {
  font-size: 12px;
  margin-bottom: 30px;
  font-family: "Kumbh Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
  font-variation-settings: "YOPQ" 300;
}
h3 {
  font-family: "Kumbh Sans", sans-serif;
  font-optical-sizing: auto;
  font-weight: 800;
  font-style: normal;
  font-variation-settings: "YOPQ" 300;
}

#registerButton {
  background-color: #23305b;
  margin: 20px auto 40px auto;
}

/* ---------------------for password eye icon----------------------------- */
.password-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.password-toggle i {
  font-size: 1.25rem;
  color: black;
}


@media (min-width: 600px) {
  #register {
    width: 550px;
  }
}

@media (max-width: 600px) {
  #register {
    border: none;
  }
}

#loginLink {
  color: #23305b;
  text-decoration: none;
}

/* ------------------------error message for validation--------------------------------- */
.error-message {
  color: red;
  font-size: 0.875rem;
  margin-top: 5px;
}

/* ------------------------loading gif--------------------------------- */
.loader {
  width: 20px; /* Adjust size as needed */
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}

/* -----------------Dialogbox if login fails----------------- */
.resetLink,
.resetLinkFailed {
  width: 380px;
  border: 1px solid black;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 20vh;
}
.resetLinkFailed {
  border: solid red 1px;
}
</style>
